module.exports = __webpack_public_path__ + "static/0083-8dd6a2307cae8138589a4337ca47a936.png";